'use client';

import { RadioGroup } from '@headlessui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@ui/Button';
import Chip from '@ui/Chip';
import Input from '@ui/Input';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { cx } from 'cva';
import TextArea from '@ui/TextArea';
import Typography from '@ui/Typography';
import { validateEmail } from '@/utils/stringHelpers';

const roles = [
  { value: 'business', label: 'Corporate' },
  { value: 'npo', label: 'Non-profit Organization' },
  { value: 'individual', label: 'Individual' },
];

const schema = yup.object().shape({
  firstName: yup
    .string()
    .required('First Name is required')
    .min(1, 'Too Short')
    .max(50, 'Too Long'),
  lastName: yup
    .string()
    .required('Last Name is required')
    .min(1, 'Too Short')
    .max(50, 'Too Long'),
  // TODO: check
  email: yup.string().email().required('Email is required'),
  // email: yup
  //   .string()
  //   .email('You must enter a valid email')
  //   .required('You must enter an email')
  //   .max(100, 'Email must be at most 50 characters long')
  //   .test(
  //     'email-availability',
  //     'An account with this email already exists. Please use a different email.',
  //     async (value) => {
  //       if (!value) return true; // Skip validation if the email field is empty

  //       const isEmailAvailable = await validateEmail(value);
  //       return !isEmailAvailable;
  //     },
  //   ),
  message: yup
    .string()
    .required('Message is required')
    .min(1, 'Message is required')
    .max(1000, 'Please shorten your message'),
  role: yup.string().required('Role is required'),
});

function ConnectModalForm(props) {
  const { onSubmit } = props;
  const form = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      role: 'business',
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = form;

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <form
      onSubmit={handleSubmit(handleFormSubmit)}
      className="flex flex-col gap-6">
      <Controller
        name="firstName"
        control={control}
        render={({ field: { ref, ...rest } }) => (
          <Input
            label="First Name"
            required
            {...rest}
            error={errors.firstName?.message}
          />
        )}
      />
      <Controller
        name="lastName"
        control={control}
        render={({ field: { ref, ...rest } }) => (
          <Input
            label="Last Name"
            required
            {...rest}
            error={errors.lastName?.message}
          />
        )}
      />

      <Controller
        name="email"
        control={control}
        render={({ field: { ref, ...rest } }) => (
          <Input
            label="Email Id"
            required
            {...rest}
            error={errors.email?.message}
          />
        )}
      />

      <Controller
        name="role"
        control={control}
        render={({ field }) => (
          <div className="flex flex-col gap-1">
            <Typography variant="h5" className="uppercase" component="label">
              You Are
            </Typography>

            <RadioGroup
              {...field}
              className="flex flex-col items-start justify-start gap-2.5 lg:flex-row">
              {roles.map((role) => (
                <RadioGroup.Option value={role.value} key={role.value}>
                  {({ checked }) => (
                    <Button
                      variant={checked ? 'filled' : 'outlined'}
                      color="transparent"
                      className={cx(
                        checked
                          ? 'border border-secondary bg-secondary-light-1 text-secondary'
                          : 'border border-text-disabled bg-transparent text-text-disabled',
                        'hover:border-secondary hover:bg-secondary-light-1 hover:text-secondary',
                      )}>
                      {role.label}
                    </Button>
                  )}
                </RadioGroup.Option>
              ))}
            </RadioGroup>
          </div>
        )}
      />

      <Controller
        name="message"
        control={control}
        render={({ field: { ref, ...rest } }) => (
          <TextArea
            label="Message"
            required
            rows="4"
            {...rest}
            error={errors.message?.message}
          />
        )}
      />

      <div className="ml-auto">
        <Button variant="filled" color="primary" type="submit" className="mt-2">
          Submit
        </Button>
      </div>
    </form>
  );
}

export default ConnectModalForm;
